export class SeatClickedEvent{
    get event(): MouseEvent {
        return this._event;
    }
    get ele(): SVGElement {
        return this._ele;
    }
    
    private readonly _ele: SVGElement;
    private readonly _event: MouseEvent;
    
    constructor(ele: SVGElement, event: MouseEvent) {
        this._event = event;
        this._ele = ele;
    }
}

export class SeatMouseOverEvent {
    get event(): MouseEvent {
        return this._event;
    }
    get ele(): SVGElement {
        return this._ele;
    }

    private readonly _ele: SVGElement;
    private readonly _event: MouseEvent;
    
    constructor(ele: SVGElement, event: MouseEvent) {
        this._ele = ele;
        this._event = event;
    }
}

export class SeatMouseOutEvent {
    get event(): MouseEvent {
        return this._event;
    }
    get ele(): SVGElement {
        return this._ele;
    }

    private readonly _ele: SVGElement;
    private readonly _event: MouseEvent;

    constructor(ele: SVGElement, event: MouseEvent) {
        this._ele = ele;
        this._event = event;
    }
}

